<template>
  <div style="width:100%;float:left;">
    <CWidgetDropdown color="gradient-info" :header="'' + data.length" text="Open Orders">
      <template #footer>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
          <CLink
            class="font-weight-bold font-xs btn-block text-info"
            color="info"
            @click="viewOrders()"
          >
            View Orders
            <CIcon name="cil-arrowRight" class="float-right" width="16"/>
          </CLink>
        </CCardFooter>
      </template>
    </CWidgetDropdown>
    <CModal
      title="Open Orders"
      :show.sync="viewModal"
      size="lg"
    >
      <div style="width:100%;float:left;">
        <h4 style="width:100%;float:left;text-align:center;font-size:13px;">Click to go to order.</h4>
        <!-- <table class="table" v-if="data">
          <thead>
            <tr>
              <th v-if="$store.state.user.user_type === 'csr'">C</th>
              <th>Log#</th>
              <th v-if="$store.state.user.user_type === 'csr'">Rep</th>
              <th>CSR</th>
              <th>Cust</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in data" @click="goToOrder(val)">
              <td v-if="$store.state.user.user_type === 'csr'">
                <div v-if="val.color_coding" style="width:20px;height:20px;" :style="'background-color:' + val.color_coding + ';'"></div>
              </td>
              <td>{{val.as400_log_number}}</td>
              <td v-if="$store.state.user.user_type === 'csr'">{{val.order.rep.name}}</td>
              <td>{{val.csr_assigned.name}}</td>
              <td>{{val.order.customer_info.customer_name}}</td>
              <td>{{val.as400_status}}</td>
              <td>{{val.local_created_at}}</td>
            </tr>
          </tbody>
        </table> -->
        <div class="all">
          <CDataTable
              :items="data"
              :fields="fields"
              column-filter
              table-filter
              sorter
              v-if="data && fields"
              @row-clicked="rowClicked"
            >
            <!-- <template #show="{item}">
              <td>
                <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
              </td>
            </template> -->
            <template #color_coding="{item}">
              <td>
                <div v-if="item.color_coding" style="width:20px;height:20px;" :style="'background-color:' + item.color_coding + ';'"></div>
              </td>
            </template>
            <!-- <template #log="{item}">
              <td>
                {{item.as400_log_number}}
              </td>
            </template>
            <template #rep="{item}">
              <td>
                {{item.order.rep.name}}
              </td>
            </template>
            <template #csr="{item}">
              <td>
                {{item.csr_assigned.name}}
              </td>
            </template>
            <template #cust="{item}">
              <td>
                {{item.order.customer_info.customer_name}}
              </td>
            </template> -->
            <!-- <template #status="{item}">
              <td>
                {{item.as400_status}}
              </td>
            </template>
            <template #date="{item}">
              <td>
                {{item.local_created_at}}
              </td>
            </template> -->
            <!-- <template #delete="{item}">
              <td>
                <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
              </td>
            </template> -->
          </CDataTable>
        </div>
      </div>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.getNewOrders = function () {
  const postData = {
    csr: this.csr,
    customer_selected: this.customer_selected
  }
  console.log(postData)
  var that = this
  axios.post(this.$apiAdress + '/api/orders/getOpenOrdersByCsr?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log(res)
    // this.data = res.data
    var arr = []
    // res.data.res.forEach(function (val) {
    //   var o = {
    //     color_coding: val.color_coding,
    //     as400_log_number: val.as400_log_number,
    //     program: val.program_name,
    //     rep: val.order.rep.name,
    //     csr_assigned: val.csr_assigned ? val.csr_assigned.name : '',
    //     customer_name: val.order.customer_info.customer_name,
    //     as400_status: val.as400_status,
    //     local_created_at: val.local_created_at,
    //     order_id: val.order_id,
    //     order_group_id: val.order_group_id
    //   }
    //   arr.push(o)
    // })
    // this.data = arr
    this.data = res.data.res
    this.$emit('set', 'open_orders_widget')
  }).catch(e => {
    console.log(e)
  })
}

methods.goToOrder = function (val) {
  this.$router.push('/order/' + val.order_id)
}

methods.viewOrders = function () {
  this.viewModal = true
}

methods.rowClicked = function (item, index, column, e) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

export default {
    // ===Component name
    name: "OpenOrdersWidget",
    // ===Props passed to component
    props: ['csr', 'customer_selected'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: [],
          viewModal: false,
          fields: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      // this.getNewOrders()
      if (this.$store.state.user.user_type === 'csr') {
        this.fields = [
                {
                  label: 'c',
                  key: 'color_coding'
                },
                {
                  label: 'log',
                  key: 'as400_log_number'
                },
                {
                  label: 'program',
                  key: 'program'
                },
                {
                  label: 'rep',
                  key: 'rep'
                },
                {
                  label: 'csr',
                  key: 'csr_assigned'
                },
                {
                  label: 'cust',
                  key: 'customer_name'
                },
                {
                  label: 'status',
                  key: 'as400_status'
                },
                {
                  label: 'date',
                  key: 'local_created_at'
                }
        ]
      } else {
        // this.fields = ['log', 'csr', 'cust', 'status', 'date']
        this.fields = [
                {
                  label: 'log',
                  key: 'as400_log_number'
                },
                {
                  label: 'program',
                  key: 'program'
                },
                {
                  label: 'csr',
                  key: 'csr_assigned'
                },
                {
                  label: 'cust',
                  key: 'customer_name'
                },
                {
                  label: 'status',
                  key: 'as400_status'
                },
                {
                  label: 'date',
                  key: 'local_created_at'
                }
        ]
      }
      this.getNewOrders()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
